module.exports = __webpack_public_path__ + "img/product-showcase-gallery-01.ab58a5f6.jpg";